<!--
  修改全局toolTip为不加箭头
-->
<template>
  <tooltip v-bind="$attrs" :visible-arrow="isShowArrow">
    <template v-slot:content>
      <slot name="content"></slot>
    </template>
    <slot name="default"></slot>
  </tooltip>
</template>

<script>
import { Tooltip } from 'element-ui'
export default {
  name: 'ElTooltip',
  props: {
    isShowArrow: {
      type: Boolean,
      default: false
    }
  },
  components: { Tooltip },
}
</script>
